import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';
import { Link } from 'react-router-dom';

const ItDevelopment = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="IT Development & Consulting"
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                    />
                    <div class="inner-container">
                        <h2>IT Development & Consulting</h2>
                        <h3>Ecosystem Analysis</h3>
                        <p>In depth analysis of IT needs, challenges, and existing IT ecosystem. No matter where you are in your journey Krisantician will guide you reach sustainability goals.</p>
                        
                        <h3>Technologies Redefined</h3>
                        <p>Technological plans that doesn’t interrupt existing business operations. This involves building an orchestration layer that involves people, processes, and systems for smoother integration of services.</p>
                        <h3>Action Oriented</h3>
                        <img alt="" src={require('../../assets/images/services/action-oriented.png')} width="100%"/>
                        
                        <h2 className="mt-5">What We Do</h2>
                        <h3>
                            <Link to="/services/it-development-consulting/application-development">Application Development</Link>
                        </h3>
                        <p>Build it right and fast. Navigate through your business challenges with latest tech trends</p>
                        <h3>
                            <Link to="/services/it-development-consulting/web-design-development">Web Design & Development</Link>
                        </h3>
                        <p>Transform Your Brand Into Visual Story. Make it alluring, functional, & dynamic</p>
                        <h3>
                            <Link to="/services/it-development-consulting/erp-development">ERP Development</Link>
                        </h3>
                        <p>Make Your Enterprise Future Ready. Streamline your business operations, monitor financial activities and mould the date into actionable insights.</p>
                        <h3>
                            <Link to="/services/it-development-consulting/product-development">Product Development</Link>
                        </h3>
                        <p>Embrace Innovation and transform the design in your mind to a digital product. Amplify your product swiftly & cost effectively.</p>
                        <h3>
                            <Link to="/services/it-development-consulting/product-maintenance">Product Maintenance</Link>
                        </h3>
                        <p>Is as important as project planning & a most overlooked factor in project success. We periodically assess the application to ensure its smooth functioning.</p>
                        <h3>
                            <Link to="/services/it-development-consulting/it-consulting">IT Consulting</Link>
                        </h3>
                        <p>Get Your Business Aligned. We help you digitalize operations, optimize portfolios, and implement the latest technologies. Our team of strategists, enterprise architects, and transformation experts would harness technology to reinvent business of any kind.</p>


                        
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ItDevelopment;